import React, { useCallback } from 'react';

import BaseSelect from '@atlaskit/select';
import { token } from '@atlaskit/tokens';

import { textifyError } from 'src/lib/error';

import withFixedOptionSupport from 'src/views/components/select/GenericAsyncSelect/withFixedOptionSupport';
import withValueTransforms from 'src/views/components/select/GenericAsyncSelect/withValueTransforms';

import { useDebouncingLoader } from './debouncingLoaderHook';
import { withFixedOnOpen } from './withFixedOnOpen';
import { withIconsSupport } from './withIconsSupport';
import { withInputClearableOnCloseOnly } from './withInputClearableOnCloseOnly';
import { withStaticOptions } from './withStaticOptions';

const Select = withValueTransforms(withFixedOptionSupport(withIconsSupport(withInputClearableOnCloseOnly(withFixedOnOpen(BaseSelect)))));

const GenericAsyncSelectInternal = ({ loadOptions, eagerOptionsLoad, debounceTimeout, name, onBlur: onBlurProp, isMulti, className, errorComponent, ...rest }) => {
  const {
    loading,
    options,
    error,
    onFilterChange,
    cancelOptionsLoading,
  } = useDebouncingLoader({ loadOptions, debounceTimeout, eagerOptionsLoad });
  const onMenuOpen = useCallback(() => onFilterChange('', true), [onFilterChange]);

  const onInputChange = useCallback((value, { action }) => {
    if (action === 'menu-close'
      || action === 'input-blur'
      || action === 'set-value') return;

    onFilterChange(value, false);
  }, [onFilterChange]);

  const onBlur = useCallback((event) => {
    if (typeof onBlurProp !== 'function') return;
    onBlurProp({ target: { name } });
  }, [name, onBlurProp]);

  return (
    <div>
      <Select
        onInputChange={onInputChange}
        isLoading={loading}
        onMenuOpen={onMenuOpen}
        onMenuClose={cancelOptionsLoading}
        closeMenuOnSelect={!isMulti}
        blurInputOnSelect={!isMulti}
        options={options}
        onBlur={onBlur}
        isMulti={isMulti}
        className={className}
        classNamePrefix={className}
        name={name}
        {...rest}
      />
      <div style={{ color: token('color.text.danger', 'red') }}>
        {error && `Can not load options: ${textifyError(error)}`}
        {/* If we have  an upstream error component we render it without textify */}
        {errorComponent && errorComponent}
      </div>
    </div>
  );
};

const GenericAsyncSelect = withStaticOptions(GenericAsyncSelectInternal);
export default GenericAsyncSelect;
